import React, {useEffect} from 'react';
import {BrowserRouter} from 'react-router-dom';
import Routers from './routes/index';
import './App.css';
import {init} from './common/request';
import {Provider} from 'react-redux';
import configureStore from './redux/store';
import i18n from './i18n/i18n';

const store = configureStore();

function App() {
  useEffect(() => {
    const language = localStorage.getItem('language') || Intl?.DateTimeFormat?.().resolvedOptions?.()?.locale || navigator.language?.split?.('_')?.[0];
    i18n.changeLanguage(language.includes('zh') ? 'zh':language.includes('ru') ? 'ru' : 'en');
  }, []);

  init({});
  return (<Provider store={store}>
    <BrowserRouter>
      <Routers/>
    </BrowserRouter>
  </Provider>);
}

export default App;
